import { Skeleton } from "primereact/skeleton";
import { ThemeContext } from "../../../theme/ThemeContext";
import { useContext } from "react";

const TicketStatCard = ({
  title,
  value,
  icon,
  bgColor = "#fff",
  subLabel,
  subValue,
  detailList = [],
  valueSuffix,
  loading = false,
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <div
      className={`h-100 border-0 rounded-2 shadow d-flex flex-column justify-content-center align-items-start px-4 py-3 ${
  !loading ? "doc-stats-card" : ""
}`}
      style={{
        backgroundColor: loading ? (isDark ? "#191919" : "#fff") : bgColor,
        minHeight: 160,
      }}
    >
      {loading ? (
        <div
          className="d-flex align-items-center"
          style={{ gap: "14px", width: "100%" }}
        >
          <Skeleton shape="circle" size="40px" />
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
          >
            <Skeleton width="60%" height="32px" />
            <Skeleton width="40%" height="15px" />
            <Skeleton width="50%" height="14px" />
            <Skeleton width="80%" height="14px" />
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center">
          <img
            src={icon}
            alt={title}
            className="me-3"
            style={{ width: 40, height: 40, objectFit: "contain" }}
          />
          <div>
            <span
              className="d-block fw-semibold text-dark"
              style={{ fontSize: 32, lineHeight: 1.1 }}
            >
              {value}
              {valueSuffix && (
                <span className="ms-1 text-dark" style={{ fontSize: 15 }}>
                  {valueSuffix}
                </span>
              )}
            </span>
            <div
              className="mt-2 text-dark"
              style={{ fontSize: 15, fontWeight: 600 }}
            >
              {title}
            </div>
            {subLabel && (
              <div className="mt-1 text-dark" style={{ fontSize: 14 }}>
                {subLabel}: <b>{subValue}</b>
              </div>
            )}
            {!!detailList.length && (
              <div className="mt-1 text-dark" style={{ fontSize: 13 }}>
                {detailList.map((d, i) => (
                  <span key={i} className="d-block">
                    {d.label}: <b style={{ fontSize: 16 }}>{d.value}</b>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketStatCard;
